module.exports = __webpack_public_path__ + "static/img/aeb16b670dea48f3d18cdedc97994300.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service_jiagou.png
// module id = DRtR
// module chunks = 1